export default "__VITE_ASSET__BC3L0uIu__"